import { ReactElement } from 'react';
import { Address } from 'viem';

import { useConnection } from 'modules/auth/hooks/useConnection';
import { ZERO } from 'modules/common/const';
import { useGetUSDAmount } from 'modules/common/hooks/useGetUSDAmount';
import { getAccountPoolEndpoint } from 'modules/pool/actions/getAccountPool';
import { getPoolEndpoint } from 'modules/pool/actions/getPool';
import { useGetPoolMetaQuery } from 'modules/pool/actions/getPoolMeta';
import { useGetPoolAPYs } from 'modules/pool/hooks/useGetPoolAPYs';

import { TableRow } from './DelegateStakingTable/TableRow';

interface IDelegateRowProps {
  poolAddress: Address;
}

export function DelegateRow({
  poolAddress,
}: IDelegateRowProps): ReactElement | null {
  const { connectionKey } = useConnection();
  const { data: pool } = getPoolEndpoint.useQueryState({
    address: poolAddress,
  });

  const { data: poolMeta } = useGetPoolMetaQuery({
    address: poolAddress,
  });

  const { data: accountPool } = getAccountPoolEndpoint.useQueryState({
    connectionKey,
    address: poolAddress,
  });

  const { poolAPYs } = useGetPoolAPYs();
  const apy = poolAPYs[poolAddress] ?? ZERO;

  const stakedAmount = accountPool?.stakedAmount ?? ZERO;
  const stakedAmountUSD = useGetUSDAmount(stakedAmount);

  if (!pool) {
    return null;
  }

  return (
    <TableRow
      amount={stakedAmount}
      amountUsd={stakedAmountUSD}
      apy={apy.decimalPlaces(2).toFormat()}
      imageIpfsLink={poolMeta?.ipfsImageLink}
      poolAddress={poolAddress}
      poolName={poolMeta?.name}
    />
  );
}
